import {Component, Inject, isDevMode, OnInit} from '@angular/core';
import {UserRole} from "../../rename/add-user-role/add-user-role.component";
import {FormBuilder, FormGroup, Validators} from "@angular/forms";
import {AngularFirestore} from "@angular/fire/compat/firestore";
import {MAT_DIALOG_DATA, MatDialogRef} from "@angular/material/dialog";
import {environment} from "../../../../environments/environment";

@Component({
  selector: 'app-add-role-permissions',
  templateUrl: './add-role-permissions.component.html',
  styleUrls: ['./add-role-permissions.component.scss']
})
export class AddRolePermissionsComponent implements OnInit {
  env = isDevMode() ? environment.testMode : environment.productionMode;
  roleForm!: FormGroup;
  defaultPermissions = [
    'Child Admission',
    'Child Prescreening',
    'Counselling',
    'Education',
    'Meal Mate',
    'Unit Sponsorship',
    'General Donation',
    'CMS',
    'Education Report',
    'Donation Report',
    'Weekly Report',
    'Hospital',
    'Unit',
    'Types',
    'Donor',
    'Event',
    'Audit Logs',
    'Inventory',
    'Vehicles',
    // Add other function names as needed
    'Audit Logs',
    'Dashboard',
    'Child Admission',
    'Donation Report',
    'Child Report',
    'Unit Sponsorship',
    'Centres',
    'Employees',
    'Tasks',
    'Ops Reports',
    'Counseling Report'
  ];
  permissionsMap: { [key: string]: UserRole[] } = {};

  constructor(
    public dialogRef: MatDialogRef<AddRolePermissionsComponent>,
    @Inject(MAT_DIALOG_DATA) public data: { selectedRole: string },
    private fb: FormBuilder,
    private firestore: AngularFirestore
  ) {
  }

  ngOnInit(): void {
    this.roleForm = this.fb.group({
      roleName: [{value: this.data?.selectedRole || '', disabled: true}, Validators.required], // auto-filled from parent selection
      functionName: [''],
      group: [''],
      all: [false],
      add: [false],
      edit: [false],
      archive: [false],
      view: [false],
      excel: [false],
      showMenu: [false]
    });
  }

  addDefaultPermissions() {
    const roleName = this.data.selectedRole;
    this.firestore.collection(this.env.userPermissions).doc('Default Permissions').collection('permissions').get().subscribe(res => {
      let permissions = res.docs.map(doc => doc.data() as UserRole);
      permissions.forEach(it => {
        this.firestore.collection(this.env.userPermissions).doc(roleName).collection('permissions').add(it)
          .then(() => {
            console.log(`Permission ${it.functionName} added successfully!`);
          })
      })
    })
  }

  async addRole() {
    const roleName = this.data.selectedRole;
    if (!roleName) return;

    const roleRef = this.firestore.collection(this.env.userPermissions).doc(roleName);

    try {
      // Create role document
      await roleRef.set({createdAt: new Date()});

      // Create new permission
      const newPermission: UserRole = {
        functionName: this.roleForm.get('functionName')?.value || '',
        group: this.roleForm.get('group')?.value || '',
        all: false,
        add: false,
        edit: false,
        archive: false,
        view: false,
        excel: false,
        showMenu: false
      };

      // Add permission document to 'permissions' subcollection
      await roleRef.collection('permissions').add(newPermission);

      console.log(`Role ${roleName} added successfully!`);
    } catch (error) {
      console.error('Error adding role:', error);
    }

    // Reset the form after the operation
    this.roleForm.reset({roleName: this.data.selectedRole});
  }
}
